import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import TabToggle from '../../../shared-components/tab-toggle/TabToggle';
// import HealthFaultAnalytics from '../station-reports/HealthFaultAnalytics';
import PowerConsumptionReportChart from '../station-reports/PowerConsumptionReportChart';
import ReportsSummary from '../station-reports/ReportsSummary';
import RevenueReportChart from '../station-reports/RevenueReportChart';
import UtilizationEfficiencyReport from '../station-reports/UtilizationEfficiencyReport';

/**
 *  Station Reports
 * @returns
 */
function StationReports() {
  const { t, i18n } = useTranslation('sidePanel');
  const [selectedTab, setSelectedTab] = useState<string>(t('summary'));

  return (
    <div dir={i18n.dir()}>
      <div style={{ marginBottom: '20px' }}>
        <TabToggle
          tabs={[
            t('summary'),
            t('revenueAndEnergyTrends'),
            t('utilizationAndEfficiency'),
            // t('healthAndFaultAnalytics'),
          ]}
          defaultTab={t('summary')}
          onChange={(tab) => setSelectedTab(tab)}
        />{' '}
      </div>
      {selectedTab === t('summary') && (
        <div>
          <ReportsSummary />
        </div>
      )}
      {selectedTab === t('revenueAndEnergyTrends') && (
        <div className="revenue-energy-trends">
          <PowerConsumptionReportChart />
          <RevenueReportChart />
        </div>
      )}
      {selectedTab === t('utilizationAndEfficiency') && (
        <div>
          <UtilizationEfficiencyReport />
        </div>
      )}
      {selectedTab === t('healthAndFaultAnalytics') && <div>{/* <HealthFaultAnalytics /> */}</div>}
    </div>
  );
}

export default StationReports;
